import React from "react";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import { useNavigate, useParams } from "react-router-dom";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { fetchCampaign } from "../../api_calls/campaignRequests";
import { useSelector } from "react-redux";
import { checkUserRole, pageAccessAllowed } from "../../api_calls/userManagement";
import { fetchReportTabsConfigForPublishedReport } from "../../api_calls/ReportSettings";
import AnalyticsDashboard from "./Reports/AnalyticsDashboard";

const CampaignAnalytics = () => {
  const userRole = checkUserRole();

  const campaignDetails = useSelector((state) => state.userSelections);
  const { id } = useParams();
  const navigate = useNavigate();
  const reportTabsConfig = typeof campaignDetails.campaign_detail !== "undefined" && typeof campaignDetails.brand_filters !== "undefined" ? fetchReportTabsConfigForPublishedReport(userRole.user_role) : [];

  React.useEffect(() => {
    fetchCampaign(id, "all", userRole.user_role);
  }, []);

  return (
    <StyledMainBox component="main" sx={{ padding: "10px 13px" }}>
      {typeof campaignDetails.campaign_detail !== "undefined" && typeof campaignDetails.brand_filters !== "undefined" && reportTabsConfig.length !== 0 && (
        <>
          {/* <AnalyticsView viewMode={userRole.user_role} /> */}
          <AnalyticsDashboard
            reportSettingArr={reportTabsConfig}
            viewMode={userRole.user_role}
            preview={false}
          />
        </>
      )}
    </StyledMainBox>
  );
};

export default AccessControl(CampaignAnalytics, [
  "campaign_reports_performance_can_view",
  "campaign_reports_impression_can_view",
], [], ["campaigns_section", "campaign_list"]);
